import React from "react";
import "./Testimonials.css";
import { Row, Col } from "reactstrap";

const data = [
  {
    text:"Vee is an extraordinary coach. She brings herself fully into her coaching relationship and is authentic, warm, challenging yet playful. She brings her wealth of experience and expertise and offers her insights in such a way that as the coachee you feel you can take what is personally useful. I’ve experienced enormous both personal and professional benefit from Vee’s coaching and would highly recommend her to anyone looking for this type of support." ,
    author:"" ,
    role:"Senior Consultant, Impact International"
  },
  {
    text:"It’s been amazing, a really great experience. The whole programme has been very fruitful. The group dynamic was very special – warm-hearted, open and intense" ,
    author:"" ,
    role:"Senior leader, Global manufacturing organisation"
  },
  {
    text:"Vee challenged me both during each session and between sessions and I always knew I had her support available and someone who would not judge…. Use Vee to provide coaching …… if someone gets 10% of the benefit I have then it will be a huge success." ,
    author:"" ,
    role:"Assistant Director, UK NHS Trust"
  },
  {
    text:"Avi designed and delivered a 3 day leadership programme for our middle managers. He tailored the training to the audience, provided great theory, management models and practical tools. The course was incredibly well rated by all the participants who not only enjoyed it but also took away real learning. I highly recommend him." ,
    author:"Louise Benfield" ,
    role:"Human Resources Manager, Marsden Building Society"
  },
]

const Testimonial = (props) => {
  return (
    <div className="single__testimonial">
      <p>
        {props.text}
      </p>

      <div className="author__info mt-4">
        <p><b>{props.author? props.author: ""}</b> - {props.role}</p>
        <img className="vam" width="32" alt="Siddham vam" src="/images/photos/vam.png"/>
      </div>
    </div>
  );
};

const Testimonials = () => {
  return (
        <Row>
          <Col lg="10" md="12" className="m-auto">
            <div className="testimonial__wrapper d-flex justify-content-between align-items-center ">
              <div className="testimonial__content w-100">
                <h4 className="mb-4">Read what clients say about us</h4>
                  {data.map(item =>
                  { return (
                    <div key={item.author+item.role}>
                     <Testimonial 
                       text={item.text}
                       author={item.author}
                       role={item.role} />
                   </div>
                  )})}
              </div>
            </div>
          </Col>
        </Row>
  );
};

export default Testimonials;